import type { FeaturePreferenceKey } from "models/types/agency-settings";
import { useAgencySettings } from "contexts/agency-settings-provider";

export function useIsAgencyFeaturePreferenceEnabled() {
  const { preferences } = useAgencySettings();

  return (feature: FeaturePreferenceKey) => {
    if (!preferences) {
      return false;
    }

    return preferences[feature];
  };
}
